import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BoxOpenIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.04804 2.09127C5.48186 1.91338 5.98962 2.00036 6.32531 2.31007L7.95469 3.81336L9.17824 2.40227C9.49403 2.03809 10.0309 1.9075 10.5003 2.08071L14.2784 3.47501C15.0432 3.75725 15.246 4.66899 14.6636 5.20636L13.2275 6.53137L14.0853 7.44107C14.5708 7.95591 14.4092 8.75381 13.7549 9.07217L12.7909 9.5413V12.0304C12.7909 12.2196 12.67 12.3894 12.4865 12.4581L8.70507 13.8745C8.25826 14.0418 7.76228 14.0418 7.31547 13.8745L3.53405 12.4581C3.35052 12.3894 3.22969 12.2196 3.22969 12.0304V9.54449L2.25867 9.07298C1.6026 8.7544 1.44137 7.95397 1.92958 7.43919L2.79166 6.53021L1.33632 5.18749C0.766967 4.6622 0.945848 3.77337 1.68163 3.47167L5.04804 2.09127ZM5.47167 3.26901L2.4797 4.49587L3.8196 5.73208L6.81157 4.50522L5.47167 3.26901ZM9.10569 4.46287L12.2008 5.73203L13.512 4.52229L10.1349 3.27596L9.10569 4.46287ZM12.1805 7.30264L8.9255 8.8042L9.63719 9.67969L12.917 8.08369L12.1805 7.30264ZM7.09492 8.80415L3.83843 7.3019L3.09648 8.08423L6.38289 9.68006L7.09492 8.80415ZM8.01027 7.74704L5.38752 6.53714L8.01027 5.46168L10.633 6.53714L8.01027 7.74704Z"
		></path>
	</svg>
))
